import React from "react";
import { TotalCateraPorSucursal } from "./Reportes/TotalCateraPorSucursal";
import { Route } from "react-router-dom";
import { TotalCarteraPorLinea } from "./Reportes/TotalCarteraPorLinea";
import { TotalCarteraDetalle } from "./Reportes/TotalCarteraDetalle";
import { TotalCarteraCliente } from "./Reportes/TotalCarteraCliente";
import { ProyeccionRecuperacionCarteraMain } from "./ProyeccionRecuperacionCartera/ProyeccionRecuperacionCarteraMain";
import { ProyeccionRecuperacionCarteraDetalle } from "./ProyeccionRecuperacionCartera/ProyeccionRecuperacionCarteraDetalle";
import { ListadoReportesCobranza } from "./ListadoReportesCobranza";
import ConvenioPagoScreen from "./ConvenioPago/ConvenioPagoScreen";
import { ConvenioPagoMain } from "./ConvenioPago/ConvenioPagoMain";

import { CPAsistenteClientesCombinar } from "./ConvenioPago/AsistenteConvenioScreen/CPAsistenteClientesCombinar";

import { CPListadoporcliente } from "./ConvenioPago/AsistenteConvenioScreen/CPListadoporcliente";
import { ReporteCobranzaMain } from "./ReporteCobranza/ReporteCobranzaMain";
import { RecuperacionCarteraMain } from "./RecuperacionCartera/RecuperacionCarteraMain";

import { ReporteRecuperacionCartera } from "./ReporteRecuperacionCartera/ReporteRecuperacionCartera";
import Objetivo_Mensual_Screen from "./ObjetivoMensual/Objetivo_Mensual_Screen";
import RecuperacionCarteraMensualScreen from "./RecuperacionCarteraMensual/RecuperacionCarteraMensualScreen";
import AgregarContactoScreen from "./ConvenioPago/AgregarContactoScreen";

import { DatosContactoScreen } from "./ConvenioPago/DatosContacto";

import { PlantillasKarbotScreen } from "./PlantillasKarbot/PlantillaKarbotScreen";

import { PedidosFacturadosScreen } from "./PedidosFacturados/PedidosFacturadosScreen";

import { ListadoClientesGestionarScreen } from "./GestionCobranza/Screen/ListadoClientesGestionarScreen";
import { ListadoClientesGestionarScreen2 } from "./GestionCobranza/Screen/ListadoClientesGestionarScreen2";
import { DetalleClientesScreen } from "./GestionCobranza/Screen/DetalleClientesScreen";
import { ListadoConveniosRealizadosScreen } from "./GestionCobranza/Screen/ListadoConveniosRealizados";
import { RegistrarCliente } from "./GestionCobranza/Screen/RegistrarCliente";
import { ListadoGestionesRealizadasScreen } from "./GestionCobranza/Screen/ListadoGestionesRealizadas";

import { ListadoClientesEstadoCuenta } from "./GestionCobranza/Screen/EstadosdeCuenta/EstadosCuentaScreen";

import { ObjecionesPagoScreen } from "./GestionCobranza/Screen/ObjecionesPagoScreen";

import { ListadoClientesJuridicoScreen } from "./CobranzaJuridico/ListadoClientesJuridicoScreen";
import { ListadoClientesJuridicosScreen } from "./Juridico/Screen/ListadoClientesJuridicosScreen";
import { DetalleClientesGestionarJuridicoScreen } from "./Juridico/Screen/DetalleClientesGestionarJuridicoScreen";
import { DetalleFacturasJuridico } from "./CobranzaJuridico/DetalleFacturasJuridico";
import { IndicadorRecuperacionScreen } from "./IndicadorRecuperacion/IndicadorRecuperacionScreen";

import { DashboardCobranzaScreen } from "./DashboardCobranza/DashboardCobranzaScreen";
import { ReporteAsignacionResponsable } from "./DashboardCobranza/ReportesDashboard/ReporteAsignacionResponsable";
import { ReporteComportamientoSaldo } from "./DashboardCobranza/ReportesDashboard/ReporteComportamientoSaldo";
import { ReporteObjetivoCartera } from "./DashboardCobranza/ReportesDashboard/ReporteObjetivoCartera";
import { ReporteRecuperacionResponsable } from "./DashboardCobranza/ReportesDashboard/ReporteRecuperacionResponsable";
import { ReporteRecuperacionCarteraDash } from "./DashboardCobranza/ReportesDashboard/ReporteRecuperacionCarteraDash";
import { ReporteTotalCartera } from "./DashboardCobranza/ReportesDashboard/ReporteTotalCartera";
import { ReporteObjetivoTotal } from "./DashboardCobranza/ReportesDashboard/ReporteObjetivoTotal";
import { ReporteProyeccionMensual } from "./DashboardCobranza/ReportesDashboard/ReporteProyeccionMensual";
import { ReporteProyeccionTotal } from "./DashboardCobranza/ReportesDashboard/ReporteProyeccionTotal";

import RecuperacionCarteraCompletaScreen from "./RecuperacionCarteraCompleta/RecuperacionCarteraCompletaScreen";
import { ReporteObjetivoTipoCartera } from "./DashboardCobranza/ReportesDashboard/ReporteObjetivoTipoCartera";
import { ReporteObjetivoResponsable } from "./DashboardCobranza/ReportesDashboard/ReporteObjetivoResponsable";
import { ListadoPagareScreen } from "./ListadoPagares/ListadoPagareScreen";
import { DashboardCobranzaScreen2 } from "./DashboardCobranza/DashboardCobranzaScreen2";
import { ReportePrestamoClientesMainScreen } from "./ReportePrestamosClientes/ReportePrestamoClientesMainScreen";
import { ListadoConveniosClienteScreen } from "./GestionCobranza/Screen/ListadosConveniosClienteScreen";
import { CondonacionInteresScreen } from "./GestionCobranza/CondonacionInteres/CondonacionInteresScreen";
import { ListadoReestructuracionesClienteScreen } from "./GestionCobranza/Screen/ListadoReestructuracionesClienteScreen";
import { ListadoComentariosClienteScreen } from "./GestionCobranza/Screen/ListadoComentariosClienteScreen";
import { NotasDescuentoScreen } from "./NotasDescuento/NotasDescuentoScreen";
import { ReferenciaBancariaMainScreen } from "./ReferenciaBancaria/ReferenciaBancariaMainScreen";

export const CreditoyCobranzaMainScreen = () => {
  return (
    <div className="main-container">
      <Route
        path="/Creditoycobranza/Resumen_saldos_cartera"
        component={() => <Objetivo_Mensual_Screen />}
      />
      <Route
        path="/Creditoycobranza/Recuperacion_cartera_Mensual"
        component={() => <RecuperacionCarteraMensualScreen />}
      />

      <Route
        path="/Creditoycobranza/RecuperacionCartera"
        component={() => <RecuperacionCarteraMain />}
      />

      <Route
        path="/Creditoycobranza/Main"
        component={() => <ListadoReportesCobranza />}
      />
      <Route
        path="/Creditoycobranza/ProyeccionRecuperacionCartera"
        component={() => <ProyeccionRecuperacionCarteraMain />}
      />
      <Route
        path="/Creditoycobranza/ProyeccionRecuperacionCarteraDetalle"
        component={() => <ProyeccionRecuperacionCarteraDetalle />}
      />

      <Route
        path="/Creditoycobranza/ResumenCartera"
        component={() => <TotalCateraPorSucursal />}
      />
      <Route
        path="/Creditoycobranza/TotalCarteraPorLinea"
        component={() => <TotalCarteraPorLinea />}
      />
      <Route
        path="/Creditoycobranza/TotalCarteraDetalle"
        component={() => <TotalCarteraDetalle />}
      />
      <Route
        path="/Creditoycobranza/TotalCarteraDetalleCliente"
        component={() => <TotalCarteraCliente />}
      />
      <Route
        path="/Creditoycobranza/GenerarConvenio"
        component={() => <ConvenioPagoScreen />}
      />
      <Route
        path="/Creditoycobranza/AgregarContacto"
        component={() => <AgregarContactoScreen />}
      />
      <Route
        path="/Creditoycobranza/ConvenioPago"
        component={() => <ConvenioPagoMain />}
      />
      <Route
        path="/Creditoycobranza/CombinarClientes"
        component={() => <CPAsistenteClientesCombinar />}
      />
      <Route
        path="/Creditoycobranza/ListadoConvenios"
        component={() => <CPListadoporcliente />}
      />
      <Route
        path="/Creditoycobranza/ReporteRecuperacionCartera"
        component={() => <ReporteRecuperacionCartera />}
      />
      <Route
        path="/Creditoycobranza/DatosContacto"
        component={() => <DatosContactoScreen />}
      />
      <Route
        path="/Creditoycobranza/PlantillasKarbot"
        component={() => <PlantillasKarbotScreen />}
      />
      <Route
        path="/Creditoycobranza/PedidosFacturados"
        component={() => <PedidosFacturadosScreen />}
      />
      <Route
        path="/Creditoycobranza/GestionClientes"
        component={() => <ListadoClientesGestionarScreen2 />}
      />
      <Route
        path="/Creditoycobranza/DetalleClientesGestionar"
        component={() => <DetalleClientesScreen />}
      />
      <Route
        path="/Creditoycobranza/DetalleClientesGestionarJuridico"
        component={() => <DetalleClientesGestionarJuridicoScreen />}
      />
      <Route
        path="/Creditoycobranza/ConveniosRealizados"
        component={() => <ListadoConveniosRealizadosScreen />}
      />
      <Route
        path="/Creditoycobranza/RegistrarCliente"
        component={() => <RegistrarCliente />}
      />
      <Route
        path="/Creditoycobranza/GestionesRealizadas"
        component={() => <ListadoGestionesRealizadasScreen />}
      />
      <Route
        path="/Creditoycobranza/ObjecionesPago"
        component={() => <ObjecionesPagoScreen />}
      />
      <Route
        path="/Creditoycobranza/CobranzaJuridico"
        component={() => <ListadoClientesJuridicoScreen />}
      />
      <Route
        path="/Creditoycobranza/ClientesJuridico"
        component={() => <ListadoClientesJuridicosScreen />}
      />
      <Route
        path="/Creditoycobranza/DetalleJuridico"
        component={() => <DetalleFacturasJuridico />}
      />
      <Route
        path="/Creditoycobranza/DashboardCobranza"
        component={() => <DashboardCobranzaScreen2 />}
      />
      <Route
        path="/Creditoycobranza/ReportePrestamosClientes"
        component={() => <ReportePrestamoClientesMainScreen />}
      />
      <Route
        path="/Creditoycobranza/ReporteTotalCartera"
        component={() => <ReporteTotalCartera />}
      />
      <Route
        path="/Creditoycobranza/ReporteComportamientoSaldo"
        component={() => <ReporteComportamientoSaldo />}
      />
      <Route
        path="/Creditoycobranza/ReporteAsignacionResponsable"
        component={() => <ReporteAsignacionResponsable />}
      />
      <Route
        path="/Creditoycobranza/ReporteObjetivoCartera"
        component={() => <ReporteObjetivoCartera />}
      />
      <Route
        path="/Creditoycobranza/ReporteRecuperacionCarteraDash"
        component={() => <ReporteRecuperacionCarteraDash />}
      />
      <Route
        path="/Creditoycobranza/ReporteRecuperacionResponsable"
        component={() => <ReporteRecuperacionResponsable />}
      />
      <Route
        path="/Creditoycobranza/ReporteObjetivoTotal"
        component={() => <ReporteObjetivoTotal />}
      />
      <Route
        path="/Creditoycobranza/ReporteObjetivoTipoCartera"
        component={() => <ReporteObjetivoTipoCartera />}
      />
      <Route
        path="/Creditoycobranza/ReporteObjetivoResponsable"
        component={() => <ReporteObjetivoResponsable />}
      />
      <Route
        path="/Creditoycobranza/ReporteProyeccionMensual"
        component={() => <ReporteProyeccionMensual />}
      />
      <Route
        path="/Creditoycobranza/ReporteProyeccionTotal"
        component={() => <ReporteProyeccionTotal />}
      />
      <Route
        path="/Creditoycobranza/ReporteRecuperacionCompleta"
        component={() => <RecuperacionCarteraCompletaScreen />}
      />

      <Route
        path="/Creditoycobranza/IndicadorRecuperacion"
        component={() => <IndicadorRecuperacionScreen />}
      />
      <Route
        path="/Creditoycobranza/Listadopagares"
        component={() => <ListadoPagareScreen />}
      />
      <Route
        path="/Creditoycobranza/ListadoConveniosCliente"
        component={() => <ListadoConveniosClienteScreen />}
      />
      <Route
        path="/Creditoycobranza/CondonacionInteres"
        component={() => <CondonacionInteresScreen />}
      />
      <Route
        path="/Creditoycobranza/ListadoReestructuracionesCliente"
        component={() => <ListadoReestructuracionesClienteScreen />}
      />
      <Route
        path="/Creditoycobranza/ListadoComentariosCliente"
        component={() => <ListadoComentariosClienteScreen />}
      />
      <Route
        path="/Creditoycobranza/NotasDescuento"
        component={() => <NotasDescuentoScreen />}
      />
      {/* <Route
        path="/Creditoycobranza/ReferenciasBancarias"
        component={() => <ReferenciaBancariaMainScreen />}
      /> */}
    </div>
  );
};
